module.exports = __webpack_public_path__ + "static/img/dynamicq.d8e13fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicq.png
// module id = E9Y9
// module chunks = 45